// material-ui
import {
  Avatar,
  Badge,
  Grid,
  List,
  ListItemButton,
  Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { Views } from 'features/enumerations'

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { CardContent } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Box } from '@mui/system'
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'
import { gridSpacing } from 'store/constant'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'

import { getUserClaims } from 'features/application/application-slice'
import { get_all_contentHouse } from 'features/contentHouse/contentHouse-slice'
import { ContentHouse } from 'models'
import { useDispatch, useSelector } from 'react-redux'
// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Simple List
  let dispatch = useDispatch()
  const theme = useTheme()
  const navigate = useNavigate()
  let claims = useSelector(getUserClaims)
  let contentHouse_list = useSelector(get_all_contentHouse)

  function render_content_houses(item: ContentHouse) {
    // if (item.state === ContentHouseState.Pending) {
    //     return null
    // }
    return {
      key: item.id,
      name: item.name,
      url: `/${Views.ContentHouses}/${item.id}`,
      imageUrl: item.contentHouseProfileImage,
    }
  }
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.load_content_houses({ fire_user: claims?.user }))
    }
  }, [claims?.user])
  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
        <MainCard title={TitleService('')} content={false}>
          <CardContent>
            {' '}
            <div>
              <List component="nav" aria-label="main mailbox folders">
                {contentHouse_list
                  .map((item) => {
                    return render_content_houses(
                      (() => {
                        function _(): ContentHouse {
                          return item
                        }
                        return _()
                      })(),
                    )
                  })
                  .filter((x) => x)
                  .map((item) => {
                    let statusColor = theme.palette.grey[500]
                    if (item) {
                      return (
                        <ListItemButton
                          key={item.key}
                          onClick={() => {
                            navigate(item.url)
                          }}
                        >
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item>
                                <Box sx={{ position: 'relative' }}>
                                  <Badge
                                    overlap="circular"
                                    badgeContent={
                                      <FiberManualRecordIcon
                                        sx={{
                                          color: statusColor,
                                          fontSize: '0.875rem',
                                        }}
                                      />
                                    }
                                    anchorOrigin={{
                                      vertical: 'bottom',
                                      horizontal: 'right',
                                    }}
                                  >
                                    <Avatar
                                      alt={`${item?.name}`}
                                      src={item.imageUrl}
                                    />
                                  </Badge>
                                </Box>
                              </Grid>
                              <Grid item xs zeroMinWidth>
                                <Typography
                                  align="left"
                                  component="div"
                                  variant="subtitle1"
                                >
                                  {`${item?.name}`}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </ListItemButton>
                      )
                    }
                    return null
                  })
                  .filter((x) => x)}
              </List>
            </div>{' '}
          </CardContent>
        </MainCard>
      </Grid>
    </Grid>
  )
}
